import { dataTrendStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendStarSolid = /*#__PURE__*/createIcon(dataTrendStarSolid)
export default IconTrendStarSolid
